// Import des icônes
import adobePhotoshopIcon from '/src/assets/softwares/adobe-photoshop-icon.png';
import adobeLightroomIcon from '/src/assets/softwares/adobe-lightroom-icon.png';
import gimpIcon from '/src/assets/softwares/gimp-icon.png';
import luminarNeoIcon from '/src/assets/softwares/luminar-neo.webp';
import dxoPhotolabIcon from '/src/assets/softwares/dxo-photolab-icon.png';
import captureOneIcon from '/src/assets/softwares/capture-one-icon.png';
import affinityIcon from '/src/assets/softwares/affinity-icon.png';
import pixlrIcon from '/src/assets/softwares/Pixlr Icon.png';
import canvaIcon from '/src/assets/softwares/canva-icon.webp';
import paint3dIcon from '/src/assets/softwares/paint-3d-icon.png';
import microsoftPhotosIcon from '/src/assets/softwares/microsoft-photos-icon.webp';
import microsoftLensIcon from '/src/assets/softwares/microsoft-lens-icon.png';
import microsoftSnippingToolIcon from '/src/assets/softwares/microsoft-snipping-tool-icon.png';
import adobeAcrobatIcon from '/src/assets/softwares/adobe-acrobat-icon.png';
import sejdaPdfIcon from '/src/assets/softwares/adobe-sejda-pdf-icon.svg';
import ilovepdfIcon from '/src/assets/softwares/ilovepdf-icon.png';
import pdfCandyIcon from '/src/assets/softwares/pdf-candy-icon.png';
import smallpdfIcon from '/src/assets/softwares/smallpdf-icon.png';
import pdfXchangeEditorIcon from '/src/assets/softwares/pdf-xchange-editor-icon.png';
import foxitReaderIcon from '/src/assets/softwares/foxit-reader-icon.png';
import pdf24CreatorIcon from '/src/assets/softwares/pdf24-creator-icon.png';
import sodaPdfIcon from '/src/assets/softwares/soda-pdf-icon.png';
import microsoftWordIcon from '/src/assets/softwares/microsoft-word-icon.png';
import microsoftOnenoteIcon from '/src/assets/softwares/microsoft-onenote-icon.png';
import microsoftEdgeIcon from '/src/assets/softwares/microsoft-edge-icon.png';
import illustratorIcon from '/src/assets/softwares/illustrator-icon.png';
import indesignIcon from '/src/assets/softwares/indesign-icon.png';
import pdfsamIcon from '/src/assets/softwares/pdfsam-icon.png';
import pdfbobIcon from '/src/assets/softwares/pdfbob-icon.png';
import libreofficeIcon from '/src/assets/softwares/libreoffice-icon.png';
import type { EditingToolType, SoftwareKey } from '../types/file.types';

export const editingTools: EditingToolType[] = [
  // Logiciels de retouche photo
  {
    name: 'adobe photoshop',
    key: 'photoshop',
    icon: adobePhotoshopIcon,
  },
  {
    name: 'adobe lightroom',
    key: 'lightroom',
    icon: adobeLightroomIcon,
  },
  {
    name: 'gimp',
    key: 'gimp',
    icon: gimpIcon,
  },
  {
    name: 'luminar neo',
    key: 'luminar_neo',
    icon: luminarNeoIcon,
  },
  {
    name: 'dxo photolab',
    key: 'dxo_photolab',
    icon: dxoPhotolabIcon,
  },
  {
    name: 'capture one',
    key: 'capture_one',
    icon: captureOneIcon,
  },
  {
    name: 'affinity photo',
    key: 'affinity_photo',
    icon: affinityIcon,
  },
  {
    name: 'pixlr',
    key: 'pixlr',
    icon: pixlrIcon,
  },
  {
    name: 'canva',
    key: 'canva',
    icon: canvaIcon,
  },
  {
    name: 'paint 3d',
    key: 'paint_3d',
    icon: paint3dIcon,
  },
  {
    name: 'microsoft photos',
    key: 'microsoft_photos',
    icon: microsoftPhotosIcon,
  },
  {
    name: 'microsoft lens',
    key: 'microsoft_lens',
    icon: microsoftLensIcon,
  },
  {
    name: 'microsoft snipping tool',
    key: 'microsoft_snipping_tool',
    icon: microsoftSnippingToolIcon,
  },

  // Logiciels d'édition de PDF
  {
    name: 'adobe acrobat',
    key: 'acrobat',
    icon: adobeAcrobatIcon,
  },
  {
    name: 'sedja pdf',
    key: 'sedja',
    icon: sejdaPdfIcon,
  },
  {
    name: 'ilovepdf',
    key: 'ilovepdf',
    icon: ilovepdfIcon,
  },
  {
    name: 'pdf candy',
    key: 'pdfcandy',
    icon: pdfCandyIcon,
  },
  {
    name: 'smallpdf',
    key: 'smallpdf',
    icon: smallpdfIcon,
  },
  {
    name: 'pdf-xchange editor',
    key: 'pdf_xchange_editor',
    icon: pdfXchangeEditorIcon,
  },
  {
    name: 'foxit reader',
    key: 'foxit_reader',
    icon: foxitReaderIcon,
  },
  {
    name: 'pdf24 creator',
    key: 'pdf24_creator',
    icon: pdf24CreatorIcon,
  },
  {
    name: 'soda pdf',
    key: 'soda_pdf',
    icon: sodaPdfIcon,
  },
  {
    name: 'microsoft word',
    key: 'word',
    icon: microsoftWordIcon,
  },
  {
    name: 'microsoft onenote',
    key: 'microsoft_onenote',
    icon: microsoftOnenoteIcon,
  },
  {
    name: 'microsoft edge',
    key: 'microsoft_edge',
    icon: microsoftEdgeIcon,
  },
  {
    name: 'adobe illustrator',
    key: 'illustrator',
    icon: illustratorIcon,
  },
  {
    name: 'adobe indesign',
    key: 'indesign',
    icon: indesignIcon,
  },
  {
    name: 'pdfsam',
    key: 'pdfsam',
    icon: pdfsamIcon,
  },
  {
    name: 'pdfbob',
    key: 'pdfbob',
    icon: pdfbobIcon,
  },
  {
    name: 'libreoffice',
    key: 'libreoffice',
    icon: libreofficeIcon,
  },
];

export const getEditingToolByKey = (
  key: SoftwareKey
): EditingToolType | undefined => {
  return editingTools.find((tool) => tool.key === (key || '').toLowerCase());
};

export const getEditingToolName = (key: SoftwareKey): string => {
  const tool = getEditingToolByKey(key);
  return tool ? tool.name : '-';
};

export const getEditingToolIcon = (key: SoftwareKey): string => {
  const tool = getEditingToolByKey(key);
  return tool ? tool.icon : '';
};
